import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=d4f155d0&scoped=true"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f155d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4f155d0')) {
      api.createRecord('d4f155d0', component.options)
    } else {
      api.reload('d4f155d0', component.options)
    }
    module.hot.accept("./BlankLayout.vue?vue&type=template&id=d4f155d0&scoped=true", function () {
      api.rerender('d4f155d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/BlankLayout.vue"
export default component.exports